import { createContext } from 'react';

const invoiceContext = createContext();

export default invoiceContext;